import { Button } from 'src/components/ui/button';
import { Dialog, DialogContent, DialogTitle } from 'src/components/ui/dialog';

const SuccessContent = ({
  message = '',
  onPopupClose,
}: {
  message?: string;
  onPopupClose: () => void;
}) => {
  return (
    <div className="grid gap-5 pt-[30px] pb-2.5 text-base text-center">
      <div>
        <p className={'font-semibold text-ebony'}>
          {message || 'You email address has been verified successfully.'}
        </p>
        <p className={'text-ebony_opacity_70'}>You can access CoSupport AI Hub now.</p>
      </div>
      <div className="w-[130px] m-auto">
        <Button className="green !mt-0 min-w-[125px]" onClick={onPopupClose}>
          Ok
        </Button>
      </div>
    </div>
  );
};

const ErrorContent = ({ onPopupClose }: { onPopupClose: () => void }) => {
  return (
    <div className="grid gap-5 pt-[30px] pb-2.5 text-base text-center">
      <div>
        <p className={'font-semibold text-error'}>Sorry, we’re facing a verification issue.</p>
        <p className={'text-error'}>Please try again later.</p>
      </div>
      <div className="w-[130px] m-auto">
        <Button className="google !mt-0 min-w-[125px]" onClick={onPopupClose}>
          Ok
        </Button>
      </div>
    </div>
  );
};

export const EmailVerificationPopup = ({
  open,
  setOpen,
  onClose = () => {},
  isSuccess,
  isError,
  message,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose?: () => void;
  isSuccess: boolean;
  isError: boolean;
  message?: string;
}) => {
  const onPopupClose = () => {
    setOpen(false);
    onClose();
  };

  const onOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      return onPopupClose();
    }

    setOpen(open);
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent
        closeButtonHidden
        className={'!outline-none backdrop-blur-[20px] bg-[rgba(255,255,255,0.80)]'}
      >
        <DialogTitle className={'hidden'}></DialogTitle>
        {isSuccess && <SuccessContent message={message} onPopupClose={onPopupClose} />}
        {isError && <ErrorContent onPopupClose={onPopupClose} />}
      </DialogContent>
    </Dialog>
  );
};
